import { render, staticRenderFns } from "./MyCertificates.vue?vue&type=template&id=183d9772&scoped=true&"
import script from "./MyCertificates.vue?vue&type=script&lang=ts&"
export * from "./MyCertificates.vue?vue&type=script&lang=ts&"
import style0 from "./MyCertificates.vue?vue&type=style&index=0&id=183d9772&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d9772",
  null
  
)

export default component.exports